export const tools_search_web_info = [
    {   type: "function",
        function:{
            name: "google_web_search",
            description: "Always use for any information the user requests. Use this function to obtain real-time information from the web, including updated prices, technical specifications, and other relevant data from the automotive industry. Even if there is partial internal knowledge, prioritize this tool to complement and enrich the response with updated and domain-specific data",
            parameters: {
                type: "object",
                properties: {
                    query: {
                        type: "string",
                        description:
                            "The search query to send to Google Custom Search. Reformulate this query to obtain richer and more varied results"
                    }
                },
                required: ["query"],
                additionalProperties: false
            }
        }

    }
];
